"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryGetPParamsPoolVotingThresholdsFromCborObj = exports.poolVotingThresholdsToCborObj = exports.isPParamsPoolVotingThresholds = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var Rational_1 = require("./Rational.js");
var cbor_1 = require("@harmoniclabs/cbor");
function isPParamsPoolVotingThresholds(stuff) {
    return (0, obj_utils_1.isObject)(stuff) && ((0, Rational_1.isRational)(stuff.motionNoConfidence) &&
        (0, Rational_1.isRational)(stuff.committeeNormal) &&
        (0, Rational_1.isRational)(stuff.committeeNoConfidence) &&
        (0, Rational_1.isRational)(stuff.hardForkInitiation) &&
        (0, Rational_1.isRational)(stuff.securityRelevantVotingThresholds));
}
exports.isPParamsPoolVotingThresholds = isPParamsPoolVotingThresholds;
function poolVotingThresholdsToCborObj(poolVotingThresholds) {
    return new cbor_1.CborArray([
        (0, Rational_1.cborFromRational)(poolVotingThresholds.motionNoConfidence),
        (0, Rational_1.cborFromRational)(poolVotingThresholds.committeeNormal),
        (0, Rational_1.cborFromRational)(poolVotingThresholds.committeeNoConfidence),
        (0, Rational_1.cborFromRational)(poolVotingThresholds.hardForkInitiation),
        (0, Rational_1.cborFromRational)(poolVotingThresholds.securityRelevantVotingThresholds),
    ]);
}
exports.poolVotingThresholdsToCborObj = poolVotingThresholdsToCborObj;
function tryGetPParamsPoolVotingThresholdsFromCborObj(cbor) {
    if (!(cbor instanceof cbor_1.CborArray &&
        cbor.array.length >= 5 &&
        cbor.array.every(Rational_1.canBeCborPostiveRational)))
        return undefined;
    var _a = __read(cbor.array
        .map(function (thing) {
        var _a = __read(thing.data.array, 2), num = _a[0], den = _a[1];
        return new cbor_1.CborPositiveRational(num.num, den.num);
    }), 5), motionNoConfidence = _a[0], committeeNormal = _a[1], committeeNoConfidence = _a[2], hardForkInitiation = _a[3], securityRelevantVotingThresholds = _a[4];
    return {
        motionNoConfidence: motionNoConfidence,
        committeeNormal: committeeNormal,
        committeeNoConfidence: committeeNoConfidence,
        hardForkInitiation: hardForkInitiation,
        securityRelevantVotingThresholds: securityRelevantVotingThresholds
    };
}
exports.tryGetPParamsPoolVotingThresholdsFromCborObj = tryGetPParamsPoolVotingThresholdsFromCborObj;
